import { render, staticRenderFns } from "./TextAreaInputComponent.vue?vue&type=template&id=44beecbd&lang=pug"
import script from "./TextAreaInputComponent.vue?vue&type=script&lang=js"
export * from "./TextAreaInputComponent.vue?vue&type=script&lang=js"
import style0 from "./TextAreaInputComponent.vue?vue&type=style&index=0&id=44beecbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports